import React from 'react';

const Permissions = () => {
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">Access denied</h1>
      <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-300">
        Your account doesn't have permission to view this page. Contact your
        administrator or{' '}
        <a className="font-medium text-zinc-900 hover:underline dark:text-zinc-100" href="mailto:support@core12.com">
          support@core12.com
        </a>{' '}
        if you believe this is in error.
      </p>
    </div>
  );
};

export default Permissions;
